var _rect, _rect2, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 38,
    height: 18,
    viewBox: "0 0 38 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "on-toggle"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 46,
    height: 26
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_0_4_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    "data-figma-bg-blur-radius": 4,
    width: 38,
    height: 18,
    rx: 9,
    fill: "#5F7F9C",
    fillOpacity: 0.41
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 3,
    y: 2,
    width: 32,
    height: 14,
    rx: 7,
    fill: "#629FD6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 28,
    cy: 9,
    r: 6,
    fill: "#F1F9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_0_4_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 18,
    rx: 9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOn);
export default __webpack_public_path__ + "static/media/toggle-on.21ffa2ef4fd903f22fc4fa54a03621a2.svg";
export { ForwardRef as ReactComponent };